import { http } from "../client";
import { mapUserObjectToUser } from "../shared/user";
var URL = "employees";
var getMany = function (userId) {
    return http.api
        .get(URL, { params: { user_id: userId } })
        .then(function (res) { return res.data.data; })
        .then(function (users) { return users.map(mapUserObjectToUser); });
};
var create = function (request) {
    return http.api
        .post(URL, {
        name: request.name,
        password: request.password,
        client_id: request.clientId,
    })
        .then(function (res) { return res.data.data; })
        .then(mapUserObjectToUser);
};
export var employeesApi = {
    getMany: getMany,
    create: create,
};
